/**
 * @generated SignedSource<<ac84089a0618b1e03fccbab6cfe11659>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptions_transaction$data = {
  readonly serviceId: string | null;
  readonly sku: {
    readonly isAvailableNow: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeactivatedQuotes_sku">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerPreQuotedOptions_transaction" | "CheckoutShippingDetails_transaction">;
  readonly " $fragmentType": "CheckoutDeliveryOptions_transaction";
};
export type CheckoutDeliveryOptions_transaction$key = {
  readonly " $data"?: CheckoutDeliveryOptions_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryOptions_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerPreQuotedOptions_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingDetails_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DeactivatedQuotes_sku"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAvailableNow",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "595625862c3696db5d225ecd34313cab";

export default node;
